import * as ReactService from "@intech/react-service";

class Versao extends ReactService.BaseService {
  constructor() {
    super("Versao");
  }

}

export const VersaoService = new Versao();
